export const emailSendStatementReport = (gettext: any, _partner?: any) => {
  return `
  <tr>
    <td>${gettext("Dear {{user_full_name}}")},</td>
  </tr>
  <tr>
    <td>${gettext("We have updated the reports for last month, and you can download the reports by clicking below")}:</td>
  </tr>
  <tr>
    <td>
      <a class="link-button" href="{{energy_statement_link}" style="color: #FFFFFF">${gettext("Download Energy Report")}</a>
    </td>
  </tr>
  <tr>
    <td>
      <a class="link-button" href="{{climate_statement_link}}" style="color: #FFFFFF">${gettext("Download Climate Report")}</a>
    </td>
  </tr>
  <tr>
    <td>
      <a class="link-button" href="{{cost_statement_link}}" style="color: #FFFFFF">${gettext("Download Cost Report")}</a>
    </td>
  </tr>
`;
};
